var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRocketWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 684,
    viewBox: "0 0 683 684",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_24_38",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 683,
    height: 684
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 1.0415H682.167V682.708H0.5V1.0415Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M236.596 333.48L236.595 333.478C231.657 328.528 223.639 328.527 218.685 333.479L218.684 333.48C213.732 338.419 213.731 346.436 218.684 351.39C223.639 356.33 231.657 356.329 236.595 351.391C241.549 346.436 241.548 338.419 236.596 333.48Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_24_38)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_24_38",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 683,
    height: 684
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M682 682.542V1.20831H0.666667V682.542H682Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_24_38)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.595 333.48L236.594 333.478C231.656 328.528 223.639 328.527 218.684 333.479L218.684 333.48C213.732 338.419 213.731 346.436 218.684 351.39C223.639 356.33 231.657 356.329 236.595 351.391C241.548 346.436 241.547 338.419 236.595 333.48Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.33333
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.359 196.302L377.066 117.582C413.239 81.4085 462.013 57.8338 509.359 42.4618C591.519 15.7952 669.333 13.8751 669.333 13.8751C669.333 13.8751 667.413 91.6885 640.746 173.848C625.374 221.195 601.799 269.968 565.626 306.142L340.774 530.995L152.214 342.435L298.359 196.302Z",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.774 497.995L265.359 568.701L114.507 417.849L185.214 375.435",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.92 384.862L472.774 512.142L359.64 625.275L345.494 526.275",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.934 337.715L57.9336 323.568L171.067 210.435L298.347 196.288",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.214 530.995L13.3335 669.875",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.933 568.701L107.613 651.021",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.507 493.274L32.1865 575.594",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M480.773 296.715C454.733 322.755 412.52 322.755 386.493 296.715C360.453 270.688 360.453 228.475 386.493 202.435C412.52 176.409 454.733 176.409 480.773 202.435C506.8 228.475 506.8 270.688 480.773 296.715Z",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.359 42.462L640.746 173.849",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.359 380.142L378.494 493.275",
    stroke: "white",
    strokeWidth: 26.6667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketWhite);
export default __webpack_public_path__ + "static/media/rocket-white.72578ed518a36d160d94ca4320f4b611.svg";
export { ForwardRef as ReactComponent };